module.exports = __webpack_public_path__ + "static/media/sun.3c2f3020.png";